import React, {useEffect, useState,} from "react";
import axios from "axios";
import {useAuthDispatch, useAuthState} from "../../Context/auth-context";
import {useNavigate,Link} from "react-router-dom";
import Notifications from "./Notifications";
import { useMediaQuery } from 'beautiful-react-hooks';
import {Drawer} from "@mui/material";
import Toast from "./Tost";
import { toast } from "react-toastify";
import {actionTypes} from "../../Context/reducer";
import BottomNavigation from "reactjs-bottom-navigation";
import 'reactjs-bottom-navigation/dist/index.css'

import ItemsDrawer from "./ItemsDrawer";
import AccountMenu from "./AccountMenu";


const bottomNavItems = [
    {
      title: 'صفحه اصلی',

      icon:<img src="../icons/mobile/home.svg" className="mobile-icon"/>



,

      activeIcon:<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 22.479 22.028">
      <path id="home" d="M2.768,14.82l.713-.232ZM1.658,8.652l.721.205ZM6.3,3.966l-.441-.607ZM1.771,8.3l.7.258ZM5.792,20.678l-.418.623Zm-.3-.215-.463.59ZM21.235,14.82l-.713-.232Zm-2.727,5.643.463.59Zm-.3.215.418.623Zm-.5-16.712.441-.607ZM22.232,8.3l-.7.258Zm.113.349-.721.205ZM12.185,1l-.028.749Zm-.367,0,.028.749ZM11.252,18.82a.75.75,0,0,0,1.5,0Zm1.5-2a.75.75,0,0,0-1.5,0ZM16,21.406l.09.745ZM3.482,14.588C2.967,13,2.6,11.874,2.409,10.956a4.236,4.236,0,0,1-.029-2.1L.937,8.446a5.705,5.705,0,0,0,0,2.817c.213,1.016.61,2.236,1.115,3.788ZM5.854,3.359c-1.32.959-2.359,1.713-3.128,2.41A5.705,5.705,0,0,0,1.067,8.045l1.409.516A4.237,4.237,0,0,1,3.733,6.88c.7-.63,1.656-1.329,3-2.308Zm-3.475,5.5q.043-.15.1-.3L1.067,8.045q-.072.2-.13.4Zm-.324,6.194c.5,1.552.9,2.773,1.325,3.72a5.7,5.7,0,0,0,1.653,2.281l.926-1.18a4.237,4.237,0,0,1-1.21-1.715C4.364,17.3,4,16.171,3.482,14.588Zm4.155,5q-.129-.087-.252-.183l-.926,1.18q.166.13.341.248Zm14.311-5.468c-.514,1.583-.883,2.713-1.267,3.569a4.237,4.237,0,0,1-1.21,1.715l.926,1.18a5.7,5.7,0,0,0,1.653-2.281c.425-.947.821-2.168,1.325-3.72Zm-2.477,5.284q-.123.1-.252.183l.837,1.245q.175-.118.341-.248Zm-.778-15.3c1.347.978,2.308,1.678,3,2.308a4.236,4.236,0,0,1,1.257,1.681l1.409-.516a5.706,5.706,0,0,0-1.659-2.277c-.769-.7-1.808-1.45-3.128-2.41Zm4.681,10.479c.5-1.552.9-2.772,1.115-3.788a5.7,5.7,0,0,0,0-2.817l-1.443.411a4.236,4.236,0,0,1-.029,2.1c-.192.918-.559,2.049-1.073,3.632Zm-.42-6.491q.054.146.1.3l1.443-.411q-.058-.2-.13-.4Zm-3.379-5.2c-1.32-.959-2.358-1.714-3.258-2.231A5.705,5.705,0,0,0,12.212.254l-.055,1.5a4.237,4.237,0,0,1,1.987.677c.814.467,1.776,1.164,3.123,2.143ZM6.736,4.572C8.083,3.594,9.045,2.9,9.859,2.429a4.237,4.237,0,0,1,1.987-.677l-.055-1.5a5.705,5.705,0,0,0-2.678.874c-.9.516-1.938,1.271-3.258,2.231ZM12.212.254q-.211-.008-.422,0l.055,1.5q.156-.006.312,0ZM15.252,16.82v4h1.5v-4Zm-6.5,4v-4h-1.5v4ZM12,13.57a3.25,3.25,0,0,1,3.25,3.25h1.5A4.75,4.75,0,0,0,12,12.07Zm0-1.5a4.75,4.75,0,0,0-4.75,4.75h1.5A3.25,3.25,0,0,1,12,13.57Zm.75,6.75v-2h-1.5v2ZM12,22.278a37.173,37.173,0,0,0,4.09-.127l-.18-1.489a36.046,36.046,0,0,1-3.91.116Zm4.09-.127a5.569,5.569,0,0,0,2.537-.85l-.837-1.245a4.1,4.1,0,0,1-1.881.606Zm-.84-1.331v.587h1.5V20.82ZM12,20.778a36.047,36.047,0,0,1-3.91-.116l-.18,1.489a37.173,37.173,0,0,0,4.09.127Zm-3.91-.116a4.1,4.1,0,0,1-1.881-.606L5.374,21.3a5.569,5.569,0,0,0,2.537.85Zm-.84.158v.587h1.5V20.82Z" transform="translate(-0.762 -0.25)" fill="#2dbd96"/>
    </svg>
    ,


        onClick: () => console.log('menu clicked')




    },



    {
      title:  'معامله',

      icon:<img src="../icons/mobile/order.svg" className="mobile-icon"/>


,


      activeIcon:<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21.5 23.42">
      <path id="order" d="M1.75,12a.75.75,0,0,0-1.5,0Zm18.5,0a.75.75,0,0,0,1.5,0ZM3.4,5.5l.54.52L3.956,6l.014-.017Zm15.2,13,.57.488.009-.011.009-.011ZM3.013,1A.75.75,0,0,0,1.513,1ZM2.254,2.986l-.75,0Zm3.68,3.68,0,.75h0Zm1.989.741a.75.75,0,0,0-.007-1.5ZM2.662,5.9l-.593.459h0Zm.355.355-.459.593h0Zm15.89,16.659a.75.75,0,1,0,1.5.007Zm.759-1.982.75,0Zm-3.68-3.68,0-.75ZM14,16.513a.75.75,0,1,0,.007,1.5Zm5.26,1.5.593-.459h0Zm-.354-.354.459-.593h0ZM2.83,6.092l-.53.531ZM11,21.25A9.25,9.25,0,0,1,1.75,12H.25A10.75,10.75,0,0,0,11,22.75Zm0-18.5A9.25,9.25,0,0,1,20.25,12h1.5A10.75,10.75,0,0,0,11,1.25ZM3.97,5.988A9.228,9.228,0,0,1,11,2.75V1.25A10.728,10.728,0,0,0,2.831,5.012ZM18.03,18.012A9.228,9.228,0,0,1,11,21.25v1.5a10.728,10.728,0,0,0,8.169-3.762ZM1.513,1,1.5,2.982,3,2.989,3.013,1ZM5.937,7.416l1.986-.009-.007-1.5L5.93,5.916ZM1.5,2.982a18.647,18.647,0,0,0,.049,1.934,2.755,2.755,0,0,0,.517,1.445l1.186-.918a1.3,1.3,0,0,1-.212-.69A17.542,17.542,0,0,1,3,2.989ZM5.93,5.916a17.542,17.542,0,0,1-1.764-.04,1.3,1.3,0,0,1-.69-.212L2.558,6.85A2.755,2.755,0,0,0,4,7.367a18.647,18.647,0,0,0,1.934.049ZM20.407,22.923l.009-1.986-1.5-.007-.009,1.986ZM15.982,16.5,14,16.513l.007,1.5L15.989,18Zm4.433,4.433A18.614,18.614,0,0,0,20.367,19a2.754,2.754,0,0,0-.517-1.445l-1.186.918a1.3,1.3,0,0,1,.212.69,17.551,17.551,0,0,1,.04,1.764ZM15.989,18a17.551,17.551,0,0,1,1.764.04,1.3,1.3,0,0,1,.69.212l.918-1.186a2.754,2.754,0,0,0-1.445-.517,18.614,18.614,0,0,0-1.934-.049ZM2.069,6.362a2.731,2.731,0,0,0,.23.261l1.06-1.062a1.231,1.231,0,0,1-.1-.118Zm.23.261a2.73,2.73,0,0,0,.258.227l.918-1.186a1.232,1.232,0,0,1-.116-.1ZM2.86,4.98l-.571.592L3.37,6.613,3.94,6.02ZM19.85,17.558a2.74,2.74,0,0,0-.2-.228l-1.078,1.043a1.23,1.23,0,0,1,.089.1Zm-.2-.228a2.74,2.74,0,0,0-.291-.26l-.918,1.186a1.238,1.238,0,0,1,.131.117Zm-.465,1.636.514-.649-1.176-.931-.514.649Z" transform="translate(-0.25 -0.25)" fill="#2dbd96"/>
    </svg>
    


    },

    {
      title: 'گزارشات',

      icon:<img src="../icons/mobile/report.svg" className="mobile-icon"/>


,


      activeIcon:<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21.509 21.5">
      <path id="report" d="M3.389,20.263l.392-.64ZM1.738,18.612l.639-.392h0Zm18.526,0-.639-.392Zm-1.651,1.651-.392-.64Zm0-15.526-.392.639Zm1.651,1.651-.639.392ZM3.389,4.737l.392.639h0ZM1.738,6.388l.639.392h0Zm15.74-4.841.541-.519h0ZM2.845,1.891l.453.6h0Zm-.99,1.032.615.429ZM18,4.13h.75v0Zm-.636,8.483a.75.75,0,0,0,0-1.5Zm-2.727-1.5a.75.75,0,0,0,0,1.5ZM9.5,4.75h3V3.25h-3Zm3,15.5h-3v1.5h3Zm-3,0c-1.651,0-2.837,0-3.762-.089a4.417,4.417,0,0,1-1.959-.538L3,20.9a5.874,5.874,0,0,0,2.6.752c1.012.1,2.282.1,3.9.1ZM.251,12.5c0,1.622,0,2.892.1,3.9A5.875,5.875,0,0,0,1.1,19l1.279-.784a4.418,4.418,0,0,1-.538-1.959c-.088-.925-.089-2.111-.089-3.762Zm3.529,7.124a4.249,4.249,0,0,1-1.4-1.4L1.1,19A5.75,5.75,0,0,0,3,20.9ZM12.5,21.75c1.622,0,2.892,0,3.9-.1a5.874,5.874,0,0,0,2.6-.752l-.784-1.279a4.417,4.417,0,0,1-1.959.538c-.925.088-2.111.089-3.762.089Zm7.124-3.529a4.249,4.249,0,0,1-1.4,1.4l.784,1.279A5.749,5.749,0,0,0,20.9,19Zm-1.4-12.844a4.249,4.249,0,0,1,1.4,1.4L20.9,6a5.75,5.75,0,0,0-1.9-1.9ZM9.5,3.25c-1.622,0-2.892,0-3.9.1A5.874,5.874,0,0,0,3,4.1l.784,1.279a4.418,4.418,0,0,1,1.959-.538C6.664,4.751,7.85,4.75,9.5,4.75ZM1.751,12.5c0-1.651,0-2.837.089-3.762a4.418,4.418,0,0,1,.538-1.959L1.1,6A5.874,5.874,0,0,0,.347,8.6c-.1,1.012-.1,2.282-.1,3.9ZM3,4.1A5.75,5.75,0,0,0,1.1,6l1.279.784a4.25,4.25,0,0,1,1.4-1.4ZM9.054,1.75h5.369V.25H9.054Zm5.369,0a15.157,15.157,0,0,1,1.86.061,1.019,1.019,0,0,1,.654.255l1.083-1.038a2.482,2.482,0,0,0-1.528-.7A16.248,16.248,0,0,0,14.423.25ZM9.054.25A39.093,39.093,0,0,0,5.048.366a5.166,5.166,0,0,0-2.656.927l.906,1.2a3.7,3.7,0,0,1,1.919-.632A37.982,37.982,0,0,1,9.054,1.75ZM1.751,9.4c0-1.765,0-3.031.1-4.011a4.161,4.161,0,0,1,.617-2.033L1.24,2.494A5.617,5.617,0,0,0,.362,5.23C.25,6.305.251,7.663.251,9.4Zm.641-8.1a5.324,5.324,0,0,0-1.152,1.2l1.231.858A3.824,3.824,0,0,1,3.3,2.489ZM18.751,4.127a11.022,11.022,0,0,0-.1-1.749,2.485,2.485,0,0,0-.629-1.35L16.937,2.066a1.013,1.013,0,0,1,.234.569,9.744,9.744,0,0,1,.08,1.5ZM.251,9.4c0,.976-.02,1.869,0,2.625l1.5-.04c-.02-.732,0-1.556,0-2.584ZM20.5,13.841H14.637v1.5H20.5ZM11.16,11.864a3.477,3.477,0,0,0,3.477,3.477v-1.5a1.977,1.977,0,0,1-1.977-1.977Zm1.5,0a1.977,1.977,0,0,1,1.977-1.977v-1.5a3.477,3.477,0,0,0-3.477,3.477Zm4.7-.75H14.637v1.5h2.727ZM12.5,4.75c1.385,0,2.445,0,3.3.053a6.622,6.622,0,0,1,1.93.336l.533-1.4a8.054,8.054,0,0,0-2.37-.431c-.915-.056-2.029-.056-3.4-.056Zm5.234.389a2.883,2.883,0,0,1,.487.237L19.006,4.1a4.381,4.381,0,0,0-.738-.361ZM17.251,4.13v.307h1.5V4.13ZM14.637,9.886h6.308v-1.5H14.637ZM21.751,12.5c0-1.375,0-2.492-.057-3.41l-1.5.094c.054.861.054,1.925.054,3.317Zm-.057-3.41A6.492,6.492,0,0,0,20.9,6l-1.279.784a5.062,5.062,0,0,1,.572,2.4ZM20.251,12.5c0,.788,0,1.472-.01,2.078l1.5.025c.01-.621.01-1.319.01-2.1Zm-.01,2.078c-.032,1.959-.176,2.925-.616,3.642L20.9,19a8.514,8.514,0,0,0,.837-4.4Zm.26.762h.49v-1.5H20.5Z" transform="translate(-0.242 -0.25)" fill="#2dbd96"/>
    </svg>
    



    },

    {

        title:'حساب کاربری',
  
  
        icon:<img src="../icons/mobile/info.svg" className="mobile-icon"/>

      ,
  
  
  
        activeIcon:<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 15.5 20.5">
        <path id="info" d="M11.25,5A3.25,3.25,0,0,1,8,8.25v1.5A4.75,4.75,0,0,0,12.75,5ZM8,8.25A3.25,3.25,0,0,1,4.75,5H3.25A4.75,4.75,0,0,0,8,9.75ZM4.75,5A3.25,3.25,0,0,1,8,1.75V.25A4.75,4.75,0,0,0,3.25,5ZM8,1.75A3.25,3.25,0,0,1,11.25,5h1.5A4.75,4.75,0,0,0,8,.25Zm-3,11h6v-1.5H5Zm6,6.5H5v1.5h6Zm-6,0A3.25,3.25,0,0,1,1.75,16H.25A4.75,4.75,0,0,0,5,20.75ZM14.25,16A3.25,3.25,0,0,1,11,19.25v1.5A4.75,4.75,0,0,0,15.75,16ZM11,12.75A3.25,3.25,0,0,1,14.25,16h1.5A4.75,4.75,0,0,0,11,11.25Zm-6-1.5A4.75,4.75,0,0,0,.25,16h1.5A3.25,3.25,0,0,1,5,12.75Z" transform="translate(-0.25 -0.25)" fill="#2dbd96"/>
      </svg>
      
        

  
      },

      
  



    {
        title: 'پشتیبانی',
  
        icon:<img src="../icons/mobile/support.svg" className="mobile-icon"/>

      
  
  ,
  
  
        activeIcon:<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21.415 21.545">
        <path id="support" d="M18.364,11.192v-.566c0-.085,0-.127,0-.163a5,5,0,0,0-4.928-4.928h-.728M21.9,11.9v-.99c0-.845,0-1.267-.032-1.623a8,8,0,0,0-7.255-7.255C14.257,2,13.835,2,12.99,2H12M8.778,9.223a2.759,2.759,0,0,0,.578,3.053l2.4,2.4a2.759,2.759,0,0,0,3.053.578,2.759,2.759,0,0,1,3.053.578l1.458,1.458c.071.071.106.106.135.137a2,2,0,0,1,0,2.706c-.029.031-.064.066-.135.137l-.886.886a2.986,2.986,0,0,1-2.759.8,17.914,17.914,0,0,1-13.6-13.6,2.986,2.986,0,0,1,.8-2.759l.886-.886c.071-.071.106-.106.137-.135a2,2,0,0,1,2.706,0c.031.029.066.064.137.135L8.2,6.17A2.759,2.759,0,0,1,8.778,9.223Z" transform="translate(-1.235 -1.25)" fill="none" stroke="#2dbd96" stroke-linecap="round" stroke-width="1.5"/>
      </svg>
  
  
      },

  ]


  const  DrawItems = [
    {
           title:'لیست دارایی',


          icon:<img src="../icons/mobile/fund.svg" className="mobile-icon"/>,
        


        url:'/fund'
    },
        {
           title:'تاریخچه معاملات',

           icon:<img src="../icons/mobile/history.svg" className="mobile-icon"/>          ,

        

        url:'/OrderDetail'
    },
        {
           title:'لیست واریز تومانی',

           icon:<img src="../icons/mobile/deposit.svg" className="mobile-icon"/>          ,




        url:'/ListVariz'
    }


    ,

    {
        title:'لیست برداشت تومانی',

        icon:<img src="../icons/mobile/wid.svg" className="mobile-icon"/>          ,


     url:'/ListBardasht'
 },

 {
    title:'لیست واریز کوینی',

    icon:<img src="../icons/mobile/deposit.svg" className="mobile-icon"/>          ,


 url:'/HistVarizCoins'
},

{
    title:'لیست برداشت کوینی ',

    icon:<img src="../icons/mobile/wid.svg" className="mobile-icon"/>          ,


 url:'/HistBardashtCoins'
},




]



const  DrawItemsUser = [


  {
    title:'احراز هویت',


    icon:<img src="../icons/mobile/auth.svg" className="mobile-icon"/>          ,

 


 url:'/ehraz'
},

{
    title:'امنیت حساب',


    icon:<img src="../icons/mobile/auth.svg" className="mobile-icon"/>

 ,
 

 url:'/securityup'
},
 


    {
        title:'اطلاعات حساب کاربری',


        icon:<img src="../icons/mobile/info.svg" className="mobile-icon"/>

     ,
     

     url:'/account'
 }

   
       

    




]


export default function Dashboard(props){
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [value,setValue] = useState(props.state)
    const [Messages,setMessages] = useState([])
    const [name,setname] = useState('')
    const [balance,setbalance] = React.useState('')
    const [blocked,setblocked] = React.useState('')
    var flag = false
    const isSmall = useMediaQuery('(max-width: 768px)')
    const [logout,setLogout] = useState()

    const  [stateDrawer,setStateDrawer] = useState(false)
    const [stateDrawerUser,setStateDrawerUser] = useState(false)




    // eslint-disable-next-line react-hooks/rules-of-hooks
    const navigate = useNavigate();
    const dispatch = useAuthDispatch()
    const {phone} = useAuthState()
    const {isAuth} = useAuthState()
    const {isEhraz} = useAuthState()



    let token = localStorage.getItem('TOKEN')
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {user} = useAuthState();

    const [modal, setModal] = useState(false);
    const Toggle = () => setModal(!modal);




    function handleCheck(item) {

        console.log(item)


        if (item.id === 0){
            navigate('/')

        }else if (item.id === 1){
            navigate('/USDT')

        }else if (item.id === 2){
            setStateDrawer(true)

        }else if (item.id === 3){
            setStateDrawerUser(true)

        }else if (item.id === 4){

            window.Goftino.open()


            
        }










    }



    const toggleDrawer = (event) => {




        setStateDrawer(false)

  };
  const toggleDrawerUser = (event) => {




    setStateDrawerUser(false)

};




    useEffect(async()=>{

        let showed = localStorage.getItem('id')
        if (showed == 0)
        {

            
         await axios.get('https://api.sinatether.com/Auth/message/',{params:{"phone":phone}}).then((res)=>{

            if (res.status == 200){



                setMessages(res.data['message'])
                localStorage.setItem('id',1)
            

               

              

                
                
                
                
                
            }



          })

        }

        




    },[])



    function handledrop(event){
        

        var element1 = document.getElementsByClassName('profile_log')
        var element2 = document.getElementsByClassName('dropdown-menu')
        element1.classList.toggle('show')
        element2.classList.toggle('show')

        

    }







   // console.log(`dashboard===================== ${token}`)

    // eslint-disable-next-line react-hooks/rules-of-hooks
     useEffect(()=>{








      axios.get(
        'https://api.sinatether.com/Auth/Hello/',
          {
              params:{phone},

          withCredentials:true
       }).then(response=>{
           setname(response.data['name'])
           setbalance(response.data['balance'])
           setblocked(response.data['blocked'])


      }).catch(Error =>{

        if (Error){
        }
       
      })
    },[token,balance,blocked])



    



        async function handelLogout(){

            setLogout(true)
    
        }


        useEffect(() => {
             function fetchData() {
                if(logout){
              // You can await here
              const response =  axios.get('https://api.sinatether.com/Auth/Logout/',{
                withCredentials:true
            }).then((res)=>{
                if (res.status == 200){
                    if(res.data['status'] == 200){
                    dispatch({
                        type:actionTypes.LOGOUT
                    })
                     console.log(res)
                     window.location.replace('/')
                    }
    
    
    
    
    
                }
            }).catch((error)=>{
                if (error){
                    toast.error("مشکلی پیش امده است مجددا تلاش فرمایید")
                }
            })
        }
              // ...
            }
            fetchData();
          }, [logout]);



       
    

    


    function showMenu() {
         console.log(isSmall)
        var navBar = document.getElementById('navbar')
        var toggle = document.getElementById('toggle_menu')

        console.log(navBar)
        if (flag==false){
            navBar.style.right = '0'
            toggle.style.boxShadow = '2px 5px'
            toggle.style.border = '1px solid black'
            flag = true

        }else if (flag){
            navBar.style.right = '-200px'
            flag = false
            toggle.style.boxShadow = ''
            toggle.style.border = ''




        }


    }

    


    function handlchange(event) {
         document.querySelectorAll('a').forEach((e)=>
             e.classList.remove('active')

         )
        event.target.classList.add('active')

    }


    return(

        <div className={'h-100 w-100'} id={'main'}>

            {Messages ? 
                Messages.map((message)=>
               
                  <Toast   message={message['message']} hideProgressBar={true} progressClassName={0}/>


            )

            :
                        <></>

        
        
                }



        {isSmall ?

        <>

        <Drawer
            anchor={'bottom'}
            open={stateDrawer}
            onClose={toggleDrawer}
          >

                <ItemsDrawer items={DrawItems} title={'گزارشات'} />

        </Drawer>


        
        <Drawer
            anchor={'bottom'}
            open={stateDrawerUser}
            onClose={toggleDrawerUser}
          >

                <ItemsDrawer items={DrawItemsUser} title={'حساب کاربری'} />

        </Drawer>



                    <div className="headernav">
                        <div className="row">
                            <div className="col-xl-12">
                                <nav className="navbar navbar-expand-lg navbar-light px-0 justify-content-between">
                                    <div className={'menuShow col-2'}>
                                        
                                        <img className="w-50"  onClick={showMenu}  id="toggle_menu" src="./icons/mobile/toggle.svg"/>

                                             </div>


                                            
                                            




                                             

                                             
                                             
                                                 <div className="dashboard_log my-2 col-2 pl-0">
                                        <div className="d-flex align-items-center">

                                                <Notifications/>
                                            </div>

                                    </div>
                                             
                                             
                                             <div className="pr-0 col-4 pl-0 text-center">
                                             <Link to={'/'}>

                                             <img class="logo-desk-css mob-logo-size" src="./images/mob-logo.svg" alt="سیناتتر"/>

                                             </Link>
  


                                       
                                                </div>


                                                
                                             <div class="col-4 px-1 px---1">

        {isEhraz ?
                                                        <AccountMenu name={name} phone={phone} setLogout={setLogout} isSmall={isSmall}/>
 


            :
                                                 <Link to="/ehraz">
                                                 <button class="btn btn-danger  buy text-large ptb-14141 mb-0 pointer ng-star-inserted   bt8217 btn-dange434" >

                                                 <span className="f25353">

                                                  <img src="./icons/mobile/shield.svg" alt=""/>


 



                                        </span>
                                                     
                                                     <span className="spn3535">
                                                     احراز هویت

                                                     </span>
                                                     </button></Link>


        }

</div>


                                   


                                </nav>
                            </div>
                        </div>
                    </div>




        </>






                :


            <div className="header dashboard pl-0">
                    <div className="container-fluid pl-0 pr-0">
                        <div className="row">
                            <div className="col-xl-12 pl-0 pr-0">
                                <nav className="navbar navbar-expand-lg navbar-light px-0 justify-content-between">
                                    <div className="account_money  ac-balance pl-0 pt-3">
                                        <ul >
                                            <li>
                                            <Link to={'/'}>

                                            <img class="logo-desk-css" src="./images/main-logo.svg" alt="سیناتتر"/>
                                            </Link>
 
                                            </li>
                                            <li className="pl16">

                                              <img src="./icons/blocked.svg" alt=""/>
    
                                                <span className={'text-large pdjsjh '}>بلوکه شده:
                                                  <span className="mytext-warning pl-1 pr-1">{new Intl.NumberFormat("fa").format(blocked)}</span>
                                                تومان</span>
                                            </li>
                                            &nbsp;&nbsp;

                                            <li className="pl16">
                                            <img src="./icons/balance.svg" alt=""/>


                                                <span className={'text-large pdjsjh '}>قدرت خرید:
                                                <span className="text-balance pl-1">
                                                {new Intl.NumberFormat("fa").format(balance)} </span>
                                                تومان

                                                    </span>

                                            </li>
                                        </ul>
                                    </div>
                                      <div className="dashboard_log my-2">
                                        <div className="d-flex align-items-center">

                                                <Notifications/>

                                                <AccountMenu name={name} phone={phone} setLogout={setLogout} isSmall={isSmall}/>
                                          
                                            </div>

                                    </div>


                                </nav>
                            </div>
                        </div>
                    </div>
                </div>









                    }


               <div className="nav" id="navbar">


                   <nav className="nav__container">
                       <div>
                           {isSmall ?
                               <span className="close mt-0 ml-0 text-white"  onClick={showMenu}>&times;</span>


                               :
                           <></>}




                           <div className="nav__list">

                               <div className="nav__items">

                                   {
                                       isSmall ?
                                           <div>



                                           <div className="fhdgfu6e64" data-toggle="dropdown">
                                           <Link to={'/'}>

                                            <img src="./images/white-logo.svg" alt=""/>

                                            </Link>

                                            </div>



                                           </div>



                                       :
                                           <>
                                            <div>



<div className="fhdgfu6e64" data-toggle="dropdown">
<Link to={'/'}>

 <img src="./images/white-logo.svg" alt=""/>

 </Link>

 </div>



</div></>
                                   }

                                   <hr/>

                                   <Link to="/" className="nav__link  w-100" id={'home'}>
                                       <img className="imgico45" src="./icons/white-icons/home.svg" alt=""/>
                                 


                                       <span className="nav__name   ">صفحه اصلی</span>



                                   </Link>


                                   <Link to="/OrderDetail"  className="nav__link"  onClick={handlchange}>

                                   <img className="imgico45" src="./icons/white-icons/history.svg" alt=""/>


                                     
                                       <span className="nav__name  ">تاریخچه سفارشات </span>
                                   </Link>


                                   <Link to="/fund" className="nav__link"  onClick={handlchange}>
                                   <img className="imgico45" src="./icons/white-icons/fund.svg" alt=""/>

                                 
                                       <span className="nav__name  ">لیست دارایی </span>
                                   </Link>

                                   <hr/>




                                   <Link to="/ListVariz" className="nav__link" onClick={handlchange}>

                                   <img className="imgico45 imgdep" src="./icons/white-icons/deposit.svg" alt=""/>

                                       <span className="nav__name  ">لیست واریز تومانی</span>
                                   </Link>
                                   <Link to="/ListBardasht" className="nav__link" onClick={handlchange}>
                                   <img className="imgico45" src="./icons/white-icons/wid.svg" alt=""/>


                                       <span className="nav__name  ">لیست برداشت تومانی</span>
                                   </Link>

                                   <Link to="/HistVarizCoins" className="nav__link" onClick={handlchange}>
                                   <img className="imgico45 imgdep" src="./icons/white-icons/deposit.svg" alt=""/>



                                   
                                       <span className="nav__name   ">لیست واریز ارزی</span>
                                   </Link>
                                   <Link to="/HistBardashtCoins" className="nav__link" onClick={handlchange}>
                                   <img className="imgico45" src="./icons/white-icons/wid.svg" alt=""/>


                                       <span className="nav__name   ">لیست برداشت ارزی</span>
                                   </Link>

                                   <hr/>




                                   <Link to="/ehraz" className="nav__link">

                                   <img className="imgico45" src="./icons/white-icons/auth.svg" alt=""/>

                                       <span className="nav__name ">احراز هویت</span>
                                   </Link>


                                   
                                   <Link to="/securityup" className="nav__link">

                                   <img className="imgico45" src="./icons/white-icons/auth.svg" alt=""/>

                                       <span className="nav__name ">امنیت حساب</span>
                                   </Link>


                                   {isSmall ? 



                                   <Link to="/Account" className="nav__link">
                                   <img className="imgico45" src="./icons/white-icons/info.svg" alt=""/>



   
                                    <span className="nav__name  "> حساب کاربری</span>
                                    </Link>

                                    

                                    :
                                    <></>
                                   }




                                   
                              <div  onClick={handelLogout} className="nav__link cpointer">

                              <img className="imgico45" src="./icons/white-icons/logout.svg" alt=""/>

                                  <span className="nav__name ">خروج</span>
                              </div>

                              </div>


                                   

                 



                           </div>
                       </div>

                       
                   </nav>
               </div>


               {isSmall?


                                    <BottomNavigation
                                    items={bottomNavItems}
                                    defaultSelected={value}
                                    activeTextColor= {'#2DBD96'}
                                    onItemClick={handleCheck}

                                    />

               
               
               :
                   <></>


               }


              </div>
    )
}